<!-- eslint-disable vue/no-parsing-error -->
<script>
import { layoutComputed } from "@/state/helpers";
import mushroom from "cem-primary-api";
import noneIconMenu from "../assets/icon/none-icon-menu.svg";
import MethodService from "../service/MethodService";
import toastr from "toastr";
import { langWeb } from "../stores/lang";
import LanguageService from "../service/LanguageService";
import DOMPurify from "dompurify";
import { Sort, Filter, Project } from "mushroomjs";
export default {
  components: {},
  data() {
    return {
      loadingService: true,
      settings: {
        minScrollbarLength: 60,
      },
      roles: "",
      listMenu: [],
      probeData: {
        id: "",
        link: "",
      },
      summaryData: {
        id: "",
        link: "",
      },
      probeId: localStorage.getItem("probeId") ?? "",
      lang_web: langWeb(),
      userRegionCodes: [],
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {};
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
    "lang_web.showLang": {
      handler: "onChangeLang",
      immediate: true,
      deep: true,
    },
  },
  created() {},

  mounted() {
    this.getMenu();
    this.fetchUserRegions();
    this.initProbeAndSummaryData();

    const response = JSON.parse(localStorage.getItem("userInfo"));
    this.roles = response.result.roles;
    this.loadDynamicRoles();

    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");
      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                let aChild = siblingCollapse.parentNode.firstChild;
                if (aChild.hasAttribute("aria-expanded")) {
                  aChild.setAttribute("aria-expanded", "false");
                }
                siblingCollapse.classList.remove("show");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2)
                item.firstElementChild.setAttribute("aria-expanded", "false");
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                let aChild = item1.parentNode.firstChild;
                if (aChild?.hasAttribute("aria-expanded")) {
                  aChild?.setAttribute("aria-expanded", "false");
                }
                item1.classList.remove("show");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.hide();
          });
        });
      });
    }
  },

  methods: {
    // lấy các thông tin dùng chung khi build URL chuyển phân hệ
    getCommonParams() {
      const tokenAccount = window.localStorage.getItem(
        "mushroom.tokens" + "[" + mushroom.$using() + "]",
      );
      const tokenFragment = MethodService.getTokenAccount(tokenAccount);
      const lang =
        localStorage.getItem("language") ??
        localStorage.getItem("language_default");
      const urlPrimary = encodeURIComponent(location.origin);

      // Lấy url_probe và url_summary từ dữ liệu probe đã cache trong localStorage
      const cachedProbe = localStorage.getItem("probeDataCache");
      const cachedSummary = localStorage.getItem("summaryProbeData");
      let probeBaseUrl = "";
      let summaryBaseUrl = "";
      try {
        if (cachedProbe) probeBaseUrl = MethodService.extractBaseUrl(JSON.parse(cachedProbe).url);
      } catch (e) {
        localStorage.removeItem("probeDataCache");
      }
      try {
        if (cachedSummary) summaryBaseUrl = MethodService.extractBaseUrl(JSON.parse(cachedSummary).url);
      } catch (e) {
        localStorage.removeItem("summaryProbeData");
      }
      const urlProbe = encodeURIComponent(probeBaseUrl);
      const urlSummary = encodeURIComponent(summaryBaseUrl);
      const typeLogin = localStorage.getItem("type_login") || "";
      return { tokenFragment, lang, urlPrimary, urlProbe, urlSummary, typeLogin };
    },

    // gắn token vào base URL (xử lý cả trường hợp có hash #) 
    appendTokenToBaseUrl(baseUrl, tokenFragment) {
      let url = "";
      if (baseUrl.includes("#")) {
        const hashIndex = baseUrl.indexOf("#");
        let beforeHash = baseUrl.substring(0, hashIndex);
        const hashValue = baseUrl.substring(hashIndex + 1);
        const separator = beforeHash.includes("?") ? "&" : "?";
        beforeHash = beforeHash + separator + tokenFragment;
        url = beforeHash + "#" + hashValue;
      } else {
        const separator = baseUrl.includes("?") ? "&" : "?";
        url = baseUrl + separator + tokenFragment;
      }
      return url;
    },

    // Build URL đầy đủ để chuyển sang phân hệ probe hoặc summary
    buildSubsystemUrl(baseUrl, { pidProbe = "", pidSummary = "" } = {}) {
      const { tokenFragment, lang, urlPrimary, urlProbe, urlSummary } = this.getCommonParams();
      let url = this.appendTokenToBaseUrl(baseUrl, tokenFragment);
      url += "&urlPrimary=" + urlPrimary;
      url += "&url_probe=" + urlProbe;
      url += "&url_summary=" + urlSummary;
      if (pidProbe) url += "&pid_probe=" + pidProbe;
      if (pidSummary) url += "&pid_summary=" + pidSummary;
      url += "&lang=" + lang;
      return url;
    },

     // Khởi tạo probeData và summaryData: luôn gọi API để đảm bảo dữ liệu mới nhất
    async initProbeAndSummaryData() {
      await this.fetchAllProbes();
    },

    async loadDynamicRoles() {
      try {
        const response = await mushroom.user_role_dynamic.getAllAsync({
          fields: "id,name",
        });
        if (response.result) {
          response.result.forEach((item) => {
            if (!this.roles.includes(item.name)) {
              this.roles.push(item.name);
            }
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // Gọi API 1 lần, tách ra probeData và summaryData
    async fetchAllProbes() {
      try {
        const response = await mushroom.probe.get_probesAsync({
          body: {},
        });

        if (response.result && response.result.length > 0) {
          const allProbes = response.result;

          // Tìm phân hệ summary (type = "summary")
          const subsystemSummary = allProbes.find((p) => p.type === "summary");

          // Tìm phân hệ probe theo type_login
          const typeLogin = localStorage.getItem("type_login") || "probe";
          const normalProbes = allProbes.filter((p) => p.type === typeLogin);

          // Lấy danh sách tỉnh để tìm code3 cho sắp xếp
          let provinces = [];
          try {
            const provinceRes = await mushroom.province.getAllAsync();
            provinces = provinceRes.result || [];
          } catch (e) {
            console.error("Có lỗi khi lấy province: %o", e);
          }

          // Sắp xếp: probe đang hoạt động lên trước, sau đó theo code3
          normalProbes.sort((a, b) => {
            const statusA = a.disabled ? 0 : 1;
            const statusB = b.disabled ? 0 : 1;
            if (statusA < statusB) return 1;
            if (statusA > statusB) return -1;
            const codeA = provinces.find((p) => p.id === a.province_id)?.code3 || "";
            const codeB = provinces.find((p) => p.id === b.province_id)?.code3 || "";
            return codeA.localeCompare(codeB);
          });

          // Xác định phân hệ probe được chọn
          let subsystemProbe = null;
          if (normalProbes.length > 0) {
            if (this.probeId) {
              subsystemProbe = normalProbes.find((p) => p.id === this.probeId);
            }
            if (!subsystemProbe) {
              subsystemProbe = normalProbes[0];
            }
          }

          // Lấy pid của từng phân hệ để truyền cross-reference
          const pidProbe = subsystemProbe?.id || "";
          const pidSummary = subsystemSummary?.id || "";

          // Build URL cho phân hệ summary
          if (subsystemSummary) {
            const url = this.buildSubsystemUrl(subsystemSummary.url, { pidProbe, pidSummary });
            this.summaryData = { id: subsystemSummary.id, link: url };
            // Cache vào localStorage
            localStorage.setItem("summaryProbeData", JSON.stringify({
              id: subsystemSummary.id,
              url: subsystemSummary.url,
            }));
          }

          // Build URL cho phân hệ probe
          if (subsystemProbe) {
            const url = this.buildSubsystemUrl(subsystemProbe.url, { pidProbe, pidSummary });
            this.probeData = { id: subsystemProbe.id, link: url };
            // lưu vào localStorage
            localStorage.setItem("probeDataCache", JSON.stringify({
              id: subsystemProbe.id,
              url: subsystemProbe.url,
            }));
          } else {
            this.probeData = { id: "", link: "" };
          }
        } else {
          this.probeData = { id: "", link: "" };
          this.summaryData = { id: "", link: "" };
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

     // Kiểm tra menu link /monitor?p_region=XX có được hiển thị không
    isMonitorMenuVisible(link) {
      if (!link) return true;
      const match = link.match(/^\/monitor\?p_region=(.+)$/);
      if (!match) return true;
      const regionCode = match[1];
      return this.userRegionCodes.includes(regionCode);
    },

    // Lấy danh sách region codes của user từ API region_user
    async fetchUserRegions() {
      try {
        const regionUserRes = await mushroom.region_user.getAllAsync(
          {},
          { preferRole: "User|NoneWebGUI" },
        );
        if (regionUserRes.result && regionUserRes.result.length > 0) {
          const regionIds = regionUserRes.result.map((item) => item.region_id);
          const regionRes = await mushroom.region.getAllAsync({
            filters: Filter.in("id", regionIds).build(),
          });
          if (regionRes.result) {
            this.userRegionCodes = regionRes.result
              .filter((region) => region.code)
              .map((region) => region.code);
          }
        }
      } catch (e) {
        console.error("Lỗi gọi region_user: ", e);
      }
    },

    // lấy data của probe (giữ lại cho trường hợp cần gọi riêng)
    async get_data_probe() {
      await this.fetchAllProbes();
    },

    // lấy data probe theo id
    async getProbeById(id) {
      try {
        const response = await mushroom.probe.findByIdAsync({
          id: id,
        });

        if (response.result) {
          const probeNew = response.result;
          const pidSummary = this.summaryData?.id || "";
          const url = this.buildSubsystemUrl(probeNew.url, { pidProbe: probeNew.id, pidSummary });
          this.probeData = { id: probeNew.id, link: url };
           // Cập nhật cache
          localStorage.setItem("probeDataCache", JSON.stringify({
            id: probeNew.id,
            url: probeNew.url,
          }));
        } else {
          this.probeData = { id: "", link: "" };
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    onRoutechange(ele) {
      this.initActiveMenu(ele.fullPath);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition =
          document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    },

    initActiveMenu(ele) {
      setTimeout(() => {
        // Tìm theo fullPath trước, fallback theo path (không query)
        let menuTree = this.listMenu.find(
          (menu) =>
            menu.children.length > 0 &&
            menu.children.map((item) => item.link).includes(ele),
        );
        if (!menuTree) {
          const elePath = ele.split("?")[0];
          menuTree = this.listMenu.find(
            (menu) =>
              menu.children.length > 0 &&
              menu.children.some(
                (item) =>
                  item.link === elePath || item.link?.split("?")[0] === elePath,
              ),
          );
        }

        if (document.querySelector("#navbar-nav")) {
          let a = document
            .querySelector("#navbar-nav")
            .querySelector('[href="#a' + menuTree?.id + '"]');
          if (a) {
            let b = document
              .querySelector("#navbar-nav")
              .querySelector('[href="#a' + menuTree?.id + '"] + div');

            a.classList.add("active");
            if (b) {
              b.classList.add("show");
              b.parentElement.children[0].classList.add("active");
              b.parentElement.children[0].setAttribute("aria-expanded", "true");
              if (b.parentElement.closest(".collapse.menu-dropdown")) {
                b.parentElement.closest(".collapse").classList.add("show");
                if (b.parentElement.closest(".collapse").previousElementSibling)
                  b.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      });
    },

    async getNumberMaxDynamic() {
      try {
        const { result } = await mushroom.system_config.listAsync({
          filters: Filter.eq("key", "max_dynamic_service_health").build(),
        });
        return result[0]?.value || 5;
      } catch (error) {
        console.error("Fetch max dynamic error:", error);
        return 5;
      }
    },

    async getMenu() {
      const maxDynamic = await this.getNumberMaxDynamic();
      try {
        const response = await mushroom.menu.views.get_treeAsync(
          {
            domains: ["primary", "summary", localStorage.getItem("type_login")],
            currentDomain: "primary",
          },
          { clientCache: true },
        );

        this.listMenu = response.result;

        let healthGroups = [];
        try {
          const { result } = await mushroom.service_health_group.listAsync({
            fields: Project.include("id", "name", "icon_id", "menu").build(),
            filters: Filter.eq("menu", true).build(),
            sort: Sort.ascending("name").build(),
            limit: maxDynamic,
          });
          if (result) healthGroups = result;
        } catch (error) {
          console.error("Fetch health groups error:", error);
        }

        if (this.listMenu && this.listMenu.length > 0) {
          this.listMenu.forEach((menu) => {
            if (menu.link === "/service-health") {
              if (!menu.children) menu.children = [];
              const hasSummary = menu.children.some(
                (child) =>
                  child.link === "/service-health" && !child.health_group_id,
              );
              if (!hasSummary) {
                menu.children.unshift({
                  id: menu.id,
                  link: "/service-health/" + menu.id + "?type=group-summary",
                  icon_id: menu.icon_id,
                  label: "Tổng hợp nhóm",
                  label_lang: {
                    en: "Group Summary",
                    vi: "Tổng hợp nhóm",
                  },
                  target_domain: "probe",
                });
              }

              healthGroups.forEach((group) => {
                const alreadyExists = menu.children.some(
                  (child) => child.health_group_id === group.id,
                );
                if (!alreadyExists) {
                  menu.children.push({
                    id: group.id,
                    health_group_id: group.id,
                    link: "/service-health/" + group.id + "?type=group",
                    label: group.name,
                    icon_id: group.icon_id,
                    label_lang: {
                      en: group.name,
                      vi: group.name,
                    },
                    target_domain: "probe",
                  });
                }
              });
            }
          });
        }
        this.initActiveMenu(window.location.pathname);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    setDomainProbe() {
      let listDomain = [];
      const valueDomain = localStorage.getItem("domainProbe");
      if (valueDomain) {
        listDomain = valueDomain.split(",");
      }
      const domain = this.probeData.link.substring(
        0,
        this.probeData.link.indexOf("/entry.html"),
      );
      if (listDomain.length === 0 || !listDomain.includes(domain)) {
        listDomain.push(domain);
      }
      localStorage.setItem("domainProbe", listDomain.join(","));
    },

    setLink(link) {
      if (link === "#") return "/";
      return link;
    },

    getMenuLabel(menuItem) {
      if (menuItem?.label && menuItem.label.trim() !== "") {
        return menuItem.label;
      }
      const lang = this.lang_web.showLang;
      if (menuItem?.label_lang?.[lang] && menuItem.label_lang[lang].trim() !== "") {
        return menuItem.label_lang[lang];
      }
      return "Summary";
    },

    getProbeLinkWithTypeLogin(targetDomain, summaryName) {
      if (targetDomain === "summary") {
        return this.getSummaryLink(summaryName, targetDomain);
      }
      const systemType = targetDomain || localStorage.getItem("type_login") || "probe";
      const typeLogin = localStorage.getItem("type_login") || "probe";
      return this.probeData.link + "&system_type=" + systemType + "&type_login=" + typeLogin;
    },

      getSummaryLink(summaryName, targetDomain) {
      // Ưu tiên dùng summaryData (probe type=summary)
      if (this.summaryData.link) {
        const baseLink = this.summaryData.link;
        const systemType = targetDomain || localStorage.getItem("type_login") || "probe";
        const typeLogin = localStorage.getItem("type_login") || "probe";
        let url = baseLink + "&system_type=" + systemType + "&type_login=" + typeLogin;
        if (summaryName) {
          url += "&summary_name=" + encodeURIComponent(summaryName);
        }
        return url;
      }

      // Fallback: dùng base URL summary từ localStorage
      const cachedSummary = localStorage.getItem("summaryProbeData");
      let summaryBaseUrl = "";
      if (cachedSummary) summaryBaseUrl = JSON.parse(cachedSummary).url || "";
      if (!summaryBaseUrl) return this.probeData.link;

      const { tokenFragment, lang, urlPrimary, urlProbe, urlSummary } = this.getCommonParams();
      const pidSummary = this.summaryData.id || "";
      const pidProbe = this.probeData.id || "";
      const separator = summaryBaseUrl.includes("?") ? "&" : "?";

      const systemType = targetDomain || localStorage.getItem("type_login") || "probe";
      const typeLogin = localStorage.getItem("type_login") || "probe";

      let url =
        summaryBaseUrl +
        separator +
        tokenFragment +
        "&pid_probe=" + pidProbe +
        "&pid_summary=" + pidSummary +
        "&urlPrimary=" + urlPrimary +
        "&url_probe=" + urlProbe +
        "&url_summary=" + urlSummary +
        "&lang=" + lang +
        "&system_type=" + systemType +
        "&type_login=" + typeLogin;

      if (summaryName) {
        url += "&summary_name=" + encodeURIComponent(summaryName);
      }

      return url;
    },

    hasQueryParams(link) {
      return link && link.includes("?");
    },

    isLinkActive(link) {
      if (!link || link === "#") return false;
      return this.$route.fullPath === link;
    },
    sanitizedLink(textLink) {
      return DOMPurify.sanitize(`#a${textLink}`);
    },
    setLinkPrimary(link, targetDomain, summaryName) {
      if (targetDomain !== "summary") this.setDomainProbe();
      const baseLink = this.getProbeLinkWithTypeLogin(targetDomain, summaryName);
      const textLink =
        link === "#"
          ? baseLink
          : baseLink + "&menu=" + link.slice(1);
      return MethodService.purifyUrl(textLink);
    },
    setLinkHealthGroup(item, targetDomain) {
      this.setDomainProbe();
      const baseLink = this.getProbeLinkWithTypeLogin(targetDomain) + "&menu=" + item.link.slice(1);
      const groupParam = `&group_id=${item.health_group_id}`;
      return MethodService.purify(baseLink + groupParam);
    },

    setIcon(iconId) {
      if (iconId) return MethodService.thumbIcon(iconId, 32);
      return noneIconMenu;
    },

    isExternalLink(link) {
      return /^https?:\/\//i.test(link);
    },

    buildExternalPrimaryLink(link) {
      const { tokenFragment, lang, urlPrimary, urlProbe, urlSummary } = this.getCommonParams();
      const params = `${tokenFragment}&lang=${lang}&urlPrimary=${urlPrimary}&url_probe=${urlProbe}&url_summary=${urlSummary}`;
      const separator = link.includes("?") ? "&" : "?";
      return link + separator + params;
    },

    notiLink() {
      toastr.error(
        LanguageService[this.lang_web.showLang.toLocaleUpperCase()]
          .toastr_not_have_probe_info ?? "toastr_not_have_probe_info",
      );
    },

    probeNotSave(link, targetDomain, summaryName) {
      if (targetDomain === "summary") {
        const baseLink = this.getSummaryLink(summaryName, targetDomain);
        if (link === "#") location.href = baseLink;
        else location.href = baseLink + "&menu=" + link.slice(1);
        return;
      }
      this.setDomainProbe();
      localStorage.setItem("probeId", this.probeData.id);
      const baseLink = this.getProbeLinkWithTypeLogin(targetDomain, summaryName);
      if (link === "#") location.href = baseLink;
      else location.href = baseLink + "&menu=" + link.slice(1);
    },

    setLinkProbeNotChildren(linkMenu, targetDomain, summaryName) {
      if (targetDomain !== "summary") this.setDomainProbe();
      const baseLink = this.getProbeLinkWithTypeLogin(targetDomain, summaryName);
      const textLink = baseLink + "&menu=" + linkMenu.slice(1);
      return MethodService.purifyUrl(textLink);
    },

    onChangeLang() {
      let langIndexInUrl = this.probeData.link.lastIndexOf("&lang=");
      let newURL =
        this.probeData.link.substring(0, langIndexInUrl) +
        "&lang=" +
        localStorage.getItem("language");
      this.probeData.link = newURL;
    },

    async logViewMenu(id, link, target, children, summaryName) {
      try {
        await mushroom.menu.log_view_menuAsync({
          body: { menu_id: id },
        });
      } catch (error) {
        console.error("Có lỗi: %o", error);
      }

      if (target === "primary") {
        if (this.isExternalLink(link)) {
          window.location.href = this.buildExternalPrimaryLink(link);
        } else {
          this.$router.push(link);
        }
      } else {
        let finalLink = "";
        if (target === "probe_health") {
          finalLink = this.setLinkHealthGroup(
            {
              link: link,
              health_group_id: id.replace("health-group-", ""),
            },
            target,
          );
        } else {
          finalLink = children?.length
            ? this.setLinkPrimary(link, target, summaryName)
            : this.setLinkProbeNotChildren(link, target, summaryName);
        }
        window.location.href = finalLink;
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <ul class="navbar-nav h-100" id="navbar-nav">
      <!-- menu động -->
      <li
        class="nav-item"
        v-for="menu in listMenu"
        :key="menu.id"
        v-show="isMonitorMenuVisible(menu.link)"
      >
        <template v-if="menu.children.length > 0">
          <a
            class="nav-link menu-link"
            :href="sanitizedLink(menu.id)"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarMultilevel"
          >
            <img
              :src="setIcon(menu?.icon_id)"
              alt="icon"
              style="width: 18px; margin-right: 10px"
            />
            <span>{{
              menu?.label_lang?.[this.lang_web.showLang] &&
              menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                ? menu.label_lang?.[this.lang_web.showLang]
                : menu.label
            }}</span>
          </a>
          <div class="collapse menu-dropdown" :id="`a${menu.id}`">
            <ul class="nav nav-sm flex-column">
              <li
                class="nav-item"
                v-for="item in menu.children"
                :key="item.id"
                v-show="isMonitorMenuVisible(item.link)"
              >
                <template v-if="item.target_domain === 'primary'">
                  <router-link
                    :to="isExternalLink(item.link) ? '#' : setLink(item.link)"
                    class="nav-link"
                    :class="{
                      'no-active': isExternalLink(item.link),
                      'router-link-exact-active':
                        hasQueryParams(item.link) && isLinkActive(item.link),
                    }"
                    :active-class="
                      isExternalLink(item.link) || hasQueryParams(item.link)
                        ? ''
                        : 'router-link-active'
                    "
                    :exact-active-class="
                      isExternalLink(item.link) || hasQueryParams(item.link)
                        ? ''
                        : 'router-link-exact-active'
                    "
                    @click.prevent="
                      logViewMenu(item.id, item.link, item.target_domain)
                    "
                  >
                    <img
                      :src="setIcon(item?.icon_id)"
                      alt="icon"
                      style="width: 18px; margin-right: 10px"
                    />
                    <span>{{
                      item?.label_lang?.[this.lang_web.showLang] &&
                      item.label_lang?.[this.lang_web.showLang].trim() !== ""
                        ? item.label_lang?.[this.lang_web.showLang]
                        : item.label
                    }}</span>
                  </router-link>
                </template>
                <template v-else>
                  <template v-if="item.target_domain === 'summary'">
                    <a
                      class="nav-link"
                      :href="setLinkPrimary(item.link, item.target_domain, getMenuLabel(item))"
                      data-key=""
                      @click.prevent="
                        logViewMenu(
                          item.id,
                          item.link,
                          item.target_domain,
                          menu.children,
                          getMenuLabel(item),
                        )
                      "
                    >
                      <img
                        :src="setIcon(item?.icon_id)"
                        alt="icon"
                        style="width: 18px; margin-right: 10px"
                      />
                      <span>{{
                        item?.label_lang?.[this.lang_web.showLang] &&
                        item.label_lang?.[this.lang_web.showLang].trim() !== ""
                          ? item.label_lang?.[this.lang_web.showLang]
                          : item.label
                      }}</span>
                    </a>
                  </template>
                  <template v-else-if="this.probeId">
                    <a
                      class="nav-link"
                      :href="
                        item.target_domain === 'probe_health'
                          ? setLinkHealthGroup(item, item.target_domain)
                          : setLinkPrimary(item.link, item.target_domain)
                      "
                      data-key=""
                      @click.prevent="
                        logViewMenu(
                          item.id,
                          item.link,
                          item.target_domain,
                          menu.children,
                        )
                      "
                    >
                      <img
                        :src="setIcon(item?.icon_id)"
                        alt="icon"
                        style="width: 18px; margin-right: 10px"
                      />
                      <span>{{
                        item?.label_lang?.[this.lang_web.showLang] &&
                        item.label_lang?.[this.lang_web.showLang].trim() !== ""
                          ? item.label_lang?.[this.lang_web.showLang]
                          : item.label
                      }}</span>
                    </a>
                  </template>
                  <template v-else-if="this.probeData.link && !this.probeId">
                    <div
                      class="nav-link"
                      data-key=""
                      @click="probeNotSave(item.link, item.target_domain, getMenuLabel(item))"
                      style="cursor: pointer"
                    >
                      <img
                        :src="setIcon(item?.icon_id)"
                        alt="icon"
                        style="width: 18px; margin-right: 10px"
                      />
                      <span>{{
                        item?.label_lang?.[this.lang_web.showLang] &&
                        item.label_lang?.[this.lang_web.showLang].trim() !== ""
                          ? item.label_lang?.[this.lang_web.showLang]
                          : item.label
                      }}</span>
                    </div>
                  </template>
                  <template v-else-if="!this.probeData.link && !this.probeId">
                    <div
                      @click="notiLink()"
                      class="nav-link"
                      style="cursor: pointer"
                    >
                      <img
                        :src="setIcon(item?.icon_id)"
                        alt="icon"
                        style="width: 18px; margin-right: 10px"
                      />
                      <span>{{
                        item?.label_lang?.[this.lang_web.showLang] &&
                        item.label_lang?.[this.lang_web.showLang].trim() !== ""
                          ? item.label_lang?.[this.lang_web.showLang]
                          : item.label
                      }}</span>
                    </div>
                  </template>
                </template>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <template v-if="menu.target_domain === 'primary'">
            <router-link
              :to="isExternalLink(menu.link) ? '#' : menu.link"
              class="nav-link menu-link"
              :class="{
                'no-active': isExternalLink(menu.link),
                'router-link-exact-active':
                  hasQueryParams(menu.link) && isLinkActive(menu.link),
              }"
              :active-class="
                isExternalLink(menu.link) || hasQueryParams(menu.link)
                  ? ''
                  : 'router-link-active'
              "
              :exact-active-class="
                isExternalLink(menu.link) || hasQueryParams(menu.link)
                  ? ''
                  : 'router-link-exact-active'
              "
              :data-key="menu.id"
              @click.prevent="
                logViewMenu(menu.id, menu.link, menu.target_domain)
              "
            >
              <img
                :src="setIcon(menu?.icon_id)"
                alt="icon"
                style="width: 18px; margin-right: 10px"
              />
              <span>{{
                menu?.label_lang?.[this.lang_web.showLang] &&
                menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                  ? menu.label_lang?.[this.lang_web.showLang]
                  : menu.label
              }}</span>
            </router-link>
          </template>
          <template v-else>
            <template v-if="menu.target_domain === 'summary'">
              <a
                class="nav-link menu-link"
                :href="setLinkProbeNotChildren(menu.link, menu.target_domain, getMenuLabel(menu))"
                data-key=""
                @click.prevent="
                  logViewMenu(menu.id, menu.link, menu.target_domain, null, getMenuLabel(menu))
                "
              >
                <img
                  :src="setIcon(menu?.icon_id)"
                  alt="icon"
                  style="width: 18px; margin-right: 10px"
                />
                <span>{{
                  menu?.label_lang?.[this.lang_web.showLang] &&
                  menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                    ? menu.label_lang?.[this.lang_web.showLang]
                    : menu.label
                }}</span>
              </a>
            </template>
            <template v-else-if="this.probeId">
              <a
                class="nav-link menu-link"
                :href="setLinkProbeNotChildren(menu.link, menu.target_domain)"
                data-key=""
                @click.prevent="
                  logViewMenu(menu.id, menu.link, menu.target_domain)
                "
              >
                <img
                  :src="setIcon(menu?.icon_id)"
                  alt="icon"
                  style="width: 18px; margin-right: 10px"
                />
                <span>{{
                  menu?.label_lang?.[this.lang_web.showLang] &&
                  menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                    ? menu.label_lang?.[this.lang_web.showLang]
                    : menu.label
                }}</span>
              </a>
            </template>
            <template v-else-if="this.probeData.link && !this.probeId">
              <div
                class="nav-link menu-link"
                data-key=""
                @click="probeNotSave(menu.link, menu.target_domain, getMenuLabel(menu))"
                style="cursor: pointer"
              >
                <img
                  :src="setIcon(menu?.icon_id)"
                  alt="icon"
                  style="width: 18px; margin-right: 10px"
                />
                <span>{{ menu.label }}</span>
              </div>
            </template>
            <template v-else-if="!this.probeData.link && !this.probeId">
              <div @click="notiLink()" class="nav-link" style="cursor: pointer">
                <img
                  :src="setIcon(menu?.icon_id)"
                  alt="icon"
                  style="width: 18px; margin-right: 10px"
                />
                <span>{{ menu.label }}</span>
              </div>
            </template>
          </template>
        </template>
      </li>

      <li class="nav-item" v-if="this.roles.includes('Admin')">
        <router-link
          to="/menu/list-menu"
          class="nav-link menu-link"
          @click.prevent="
            logViewMenu('ConfigMenu', '/menu/list-menu', 'primary')
          "
        >
          <i class="ri-menu-add-line"></i>
          <span>{{ $t("t-config-menu") }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<style scoped>
.loading-container {
  height: 200px;
}
li {
  width: 100%;
}
span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
</style>
